import React from 'react';
import { Box, Center, Heading, Image, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import chargerImg from '../../../assets/images/evse_charger_station_offline.svg';
import chargerStatusImg from '../../../assets/images/evse_charger_status_offline.svg';
import { ArcButton } from '../../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../../common/components/SlidingAnimationPageBase';
import { COMPONENT_MIN_HEIGHT, TOP_NAV_SPACING_AFFORDANCE } from '../../../common/constants';

type Props = {
  isDeviceRemoved?: boolean;
};

/* istanbul ignore next -- @preserve */
export const NoDevice = ({ isDeviceRemoved }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <SlidingAnimationPageBase
      px={4}
      title={t('Common.device setup')}
      backURL={`../../../home`}
      customNavigationDirection="forward"
    >
      <Box display="flex" flexDirection="column" h={`calc(${COMPONENT_MIN_HEIGHT} - ${TOP_NAV_SPACING_AFFORDANCE})`}>
        <Center pt={4} pb={2}>
          <Box data-testid="ev-image-container" position="relative" w="48vw" h="48vw">
            <Image src={chargerStatusImg} alt="No EV Charger" w="100%" h="100%" />
            <Image
              src={chargerImg}
              alt="EV Charger"
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              h="62%"
            />
          </Box>
        </Center>

        <VStack align="stretch" spacing={2} mb={2}>
          <Heading fontSize={24} fontWeight={600} textAlign="center" data-testid="no-device-title">
            {isDeviceRemoved ? t('Set Up Hardware.charger removed') : t('EVSE.charger not found')}
          </Heading>
        </VStack>

        <VStack align="stretch" spacing={2}>
          <Text data-testid="ev-add-text" textAlign="center">
            {t('Set Up Hardware.add new charger text')}
          </Text>
        </VStack>

        <Center mt="auto" mb={5} flexDir={'column'}>
          <ArcButton
            data-testid="ev-charger-add"
            onClick={() => navigate(`../device-scan`)}
            w="100%"
            py={6}
            mt="auto"
            arcColor="#3DCD57"
          >
            {t('Set Up Hardware.add charger')}
          </ArcButton>
        </Center>
      </Box>
    </SlidingAnimationPageBase>
  );
};
